import React from 'react'

import './ToggleSwitch.sass'

interface ToggleSwitchProps {
  value: boolean
  onChange?: (newValue: boolean) => void
}

const ToggleSwitch = ({ value, onChange }: ToggleSwitchProps) => {
  const handleChange = () => {
    if (onChange) {
      onChange(!value)
    }
  }
  return (
    <div className={`switcher ${value ? 'right' : 'left'}`}>
      <div className="toggle" onClick={handleChange} />
    </div>
  )
}

export default ToggleSwitch
